import { Component, Input, input } from '@angular/core';
import { ReplaceTextPipe } from '../../pipe/replace-text.pipe';
import { PlanDashboardTO } from '../../models/planModel';
import { ModalService } from 'src/app/core/services/modal.service';
import { CommonModule } from '@angular/common';
import { MembershipCardModalComponent } from "../membershipcard-modal/membershipcard-modal.component";
import { MemberService, MemberSituationEnum } from 'src/app/core/services/member.service';
import { CommonService } from 'src/app/core/services/common.service';

@Component({
  selector: 'app-plan-dependent-card',
  standalone: true,
  imports: [ReplaceTextPipe, CommonModule, MembershipCardModalComponent],
  templateUrl: './plan-dependent-card.component.html',
  styleUrl: './plan-dependent-card.component.scss'
})
export class PlanDependentCardComponent {

  plan = input.required<PlanDashboardTO>();
  @Input() dependentData: any;
  @Input() memberData: any;
  @Input() memberShipCard: any;
  memberSeatNumber: any;
  showDateStart = false;
  isSecondaryPlan: boolean = localStorage.getItem('isSecondaryPlan') === 'true';

  public styles: { [key: string]: string };

  carteirinhaImg = localStorage.getItem('imageLogo');

  currentPlan!: any;
  virtualCard = localStorage.getItem('virtualCard');
  hasVitoria = window.location.href.toLowerCase().includes('vitoria');

  constructor(
    private modalService: ModalService,
    private memberService: MemberService,
    public commonService: CommonService
  ) {
    this.showDateStart = localStorage.getItem('enableTextReplace') !== 'true';
  }

  ngOnInit(): void {
    this.styles = {
      '--primaryColor': localStorage.getItem('primaryColor') as string,
      '--membership-card-size': localStorage.getItem('membershipCardSize') as string + 'rem'
    };
    this.getMemberSeatNumberDashboardData();
    this.getMemberShipCardDashboardData();
  }

  getMemberSeatNumberDashboardData() {
    this.memberService
      .getMemberSeatNumberDashboardData(this.plan().member.id, this.plan().id)
      .subscribe((res) => {
        this.memberSeatNumber = {
          ...res,
          seatNumber: res.seatNumber[0] + '-' + res.seatNumber.slice(1),
          planName: this.plan().plan.planName
        };
      });
  }

  getMemberShipCardDashboardData() {
    this.memberService
      .getMemberShipCardDashboardData(this.plan().member.id, this.plan().id)
      .subscribe((res) => {
        this.memberShipCard.src = this.commonService.getImageStr(res.imgPortalPlanId);
      });
  }

  showCarteirinha() {
    // this.trigger$.next(true);
    this.modalService.open('membershipCardModal');
  }

  checkDaysEndData() {
    let planEndDate = new Date(this.currentPlan?.planEndDate);
    let currentDate = new Date();
    let diff = Math.abs(planEndDate.getTime() - currentDate.getTime());
    let days = Math.ceil(diff / (1000 * 60 * 60 * 24));
    return days;
  }

  hasQrCode() {
    return (this.memberData?.memberSituation?.id === MemberSituationEnum.Adimplente || this.isSecondaryPlan) &&
      this.memberShipCard != null && this.virtualCard == 'true';
  }
}
